var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"kv-amount"},[_vm._v(_vm._s(_vm.parts.prefix)),(_vm.parts.cents)?_c('span',{staticClass:"kv-amount-cents"},[_vm._v(_vm._s(_vm.parts.cents))]):_vm._e(),_vm._v(_vm._s(_vm.parts.suffix))])
}
var staticRenderFns = []

export { render, staticRenderFns }